module.exports = __webpack_public_path__ + "img/organisations-leaflets.b7bc2b56.jpg";